import ArrowLeftThinIcon from '@assets/icons/arrow-left-thin.svg';
import CloseIcon from '@assets/icons/close.svg';
import React, { useEffect } from 'react';
import { AnalyticEvent } from '@/analytics/fennel/registry';
import { APP_MODAL_ROUTES } from '@/navigators/routes';
import { AppModalStackParams } from '@/navigators/types';
import { createStyles } from '@/contexts/theme-context';
import { fennelTrack } from '@/analytics/fennel/hook';
import { ItemDetails } from '@/components/items/item-details';
import { ModalContainer } from '@/components/modal-container';
import { Platform, TouchableOpacity } from 'react-native';
import { StackScreenProps } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';

type Props = StackScreenProps<
  AppModalStackParams,
  APP_MODAL_ROUTES.ItemDetails
>;

export const ItemDetailsModalSheet: React.FC<Props> = ({ route }) => {
  const { restaurantUUID, supplierUUID, variantPackUUID, origin } =
    route.params;
  const { goBack } = useNavigation();
  const [styles, theme] = useStyles();

  useEffect(() => {
    fennelTrack(AnalyticEvent.ITEM_DETAIL_VIEW, {
      origin,
      restaurantUUID,
      screenName: APP_MODAL_ROUTES.ItemDetails,
      supplierUUID,
      variantPackUUID,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModalContainer
      navigationHeaderProps={{
        actions: [
          {
            component: (
              <TouchableOpacity accessibilityRole="button" onPress={goBack}>
                {Platform.OS === 'web' ? (
                  <ArrowLeftThinIcon
                    fill={theme.sk.color.icon.primary}
                    height={24}
                    width={24}
                  />
                ) : (
                  <CloseIcon
                    fill={theme.sk.color.icon.primary}
                    height={24}
                    width={24}
                  />
                )}
              </TouchableOpacity>
            ),
          },
        ],
        containerStyle: styles.header,
        showBackButton: false,
        showShadow: false,
      }}
      showLargeLayoutCloseButton={false}
    >
      <ItemDetails
        restaurantUUID={restaurantUUID}
        supplierUUID={supplierUUID}
        variantPackUUID={variantPackUUID}
      />
    </ModalContainer>
  );
};

const useStyles = createStyles(() => ({
  header: {
    alignItems: 'flex-start',
  },
}));
